import { createApp, h } from "vue/dist/vue.esm-bundler";
import { createInertiaApp } from "@inertiajs/vue3";
import { createPinia } from "pinia";
import TanstackTable from "../components/views/TanstackTable.vue";
import TanstackTableRemote from "../components/views/TanstackTableRemote.vue";
import RemotePagination from "../components/views/RemotePagination.vue";
import { MazUi } from "maz-ui/plugins/maz-ui";
import { mazUi } from "@maz-ui/themes";
import { en } from "@maz-ui/translations";
import "maz-ui/styles";
import PhoneNumberInput from "../components/views/PhoneNumberInput.vue";
import "@hotwired/turbo-rails";
import "../controllers";
import "trix";
import "@rails/actiontext";

const pages = import.meta.glob("../pages/**/*.vue", { eager: true });
const pinia = createPinia();

function mountVueComponents() {
  const isInertiaPage = document.querySelector("[data-page]");

  if (isInertiaPage != null) {
    createInertiaApp({
      resolve: (name) => {
        return pages[`../pages/${name}.vue`];
      },
      setup({ el, App, props, plugin }) {
        const vueApp = createApp({
          render: () => h(App, props),
        });
        vueApp.use(plugin).use(pinia).mount(el);
      },
    });
    return;
  }

  const configs = [
    {
      selector: '[data-tanstack-table="vue"]',
      component: ["TanstackTable", TanstackTable],
    },
    {
      selector: '[data-tanstack-table-remote="vue"]',
      component: ["TanstackTableRemote", TanstackTableRemote],
    },
    {
      selector: '[data-phone-number-input="vue"]',
      component: ["PhoneNumberInput", PhoneNumberInput],
    },
  ];

  configs.forEach((c) => createVueApp(c));
}

const createVueApp = function (config) {
  const wrappers = document.querySelectorAll(config.selector);
  if (wrappers.length > 0) {
    wrappers.forEach((element) => {
      if (!element.__vue_app__) {
        const hasChildComponent =
          element.children.length > 0 &&
          element.children[0].tagName.includes("-");

        if (hasChildComponent) {
          const app = createApp();
          app.component(...config.component);
          app.use(MazUi, {
            theme: {
              preset: mazUi,
              mode: "light",
            },
            translations: { messages: { en } },
          });
          if (config.store) {
            app.use(config.store);
          }
          app.mount(element);
        } else {
          const props = {};
          const dataset = element.dataset;

          const selectorKey = config.selector
            .replace(/\[data-|-\]/g, "")
            .split("=")[0]
            .replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());

          Object.keys(dataset).forEach((key) => {
            if (key !== selectorKey) {
              props[key] = dataset[key];
            }
          });

          const app = createApp({
            render: () => h(config.component[1], props),
          });

          app.use(MazUi, {
            theme: {
              preset: mazUi,
              mode: "light",
            },
            translations: { messages: { en } },
          });

          if (config.store) {
            app.use(config.store);
          }

          app.mount(element);
        }
      }
    });
  }
};
document.addEventListener("turbo:load", mountVueComponents);
document.addEventListener("turbo:render", mountVueComponents);
mountVueComponents();
